"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = __importDefault(require("lodash/compact"));
const defaultKey = ['objectives'];
const keys = {
    default: defaultKey,
    objectives: (page, params) => {
        return (0, compact_1.default)([...defaultKey, page, params]);
    },
    totalObjectives: (params) => {
        return (0, compact_1.default)([...defaultKey, 'total-objectives', params]);
    },
    needResponseCount: (type, params) => {
        return (0, compact_1.default)([...defaultKey, 'count', type, params]);
    }
};
exports.default = keys;
